import { styled } from "@mui/material/styles";
import theme, { mobileTypography } from "src/config/theme";
import { palette, shadows, typography } from "src/config/theme";
import { Avatar, Box, Chip, Typography, alpha } from "@mui/material";
import ButtonComponent from "src/components/shared/Button";
import AppMenu from "src/components/shared/Menu";


export const AllTabsMainContainer = styled(Box)({
    height: '756px',
    boxShadow: theme.shadows[1],
    borderRadius: '10px',
    border: `1px solid ${alpha(theme.palette.gery.black, 0.1)}`,
    backgroundColor: theme.palette.gery.white,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'space-between',
    position: 'relative',
    [theme.breakpoints.down('md')]: {
        boxShadow: 'none',
        backgroundColor: 'transparent',
        border: 'none'
    }
})

export const PatientHeaderContainer = styled(Box)({
    backgroundColor: alpha(palette.gery.white, 0.8),
    backdropFilter: 'blur(12px)',
    height: '108px',
    padding: '0px 32px 0 32px',
    borderBottom: `1px solid ${alpha(palette.gery.black, 0.05)}`,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    [theme.breakpoints.down('md')]: {
        height: '80px !important',
        width: '100%',
        padding: '0px 20px'
    },
})

export const Part1 = styled(Box)({
    // width: '729px',
    height: '70px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: '10px',


})
export const Part2 = styled(Box)({
    display: 'flex',
    alignItems: 'center',
    gap: '24px',
    marginLeft: 'auto',
    flexShrink: 0,
    [theme.breakpoints.down('md')]: {
        width: 'auto',
        height: '40px',
        gap: '8px',
        justifyContent: 'flex-end'
    },
})
export const AddItemButton = styled(ButtonComponent)({
    width: '172px',
    height: '52px',
    borderRadius: '12px',
    padding: '10px 18px',
    background: palette.primary.main,
    border: `1px solid ${alpha(palette.gery.black, 0.14)}`,
    boxShadow: shadows[1],
    color: palette.gery.white,
    justifyContent: 'space-between',
    '&:hover': {
        color: theme.palette.primary.main,
    }
})

export const MenuOptions = styled(AppMenu)({

    "&.MuiPaper-root": {
        borderRadius: "12px",
        boxShadow: shadows[2],
        // padding: "8px 0",
        border: '1px solid black'
    },

})

export const TwoIconContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    width: '206px',
    height: '52px',
    [theme.breakpoints.down('md')]: {
        width: '86px',
        height: '40px',
        gap: '6px'
    },
})

export const PrevNextIconContainer = styled(Box)({
    width: '102px',
    height: '52px',
    borderRadius: '12px',
    padding: '10px 18px',
    gap: '6px',
    // boxShadow: shadows[1],
    color: palette.gery.black,
    ...typography.h5,
    cursor: 'pointer',
    display: 'flex',
    gap: '5px',
    alignItems: 'center',

    [theme.breakpoints.down('md')]: {
        width: '40px',
        height: '40px',
        padding: '10px'

    },
})
export const PatientDp = styled(Avatar)({
    width: '70px',
    height: '70px',
    borderRadius: '12px',
    padding: '10px',
    backgroundColor: palette.primary.light3,
    ...typography.h1,
    color: palette.primary.main,
    [theme.breakpoints.down('md')]: {
        width: '48px',
        height: '48px',
        ...mobileTypography.h3
    },
})
export const PatientDetails = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    gap: '12px',
    flexGrow: 1,
    minWidth: 0,
    [theme.breakpoints.down('md')]: {
        width: 'auto'
    },

})
export const Name_TagContainer = styled(Box)({
    display: 'flex',
    // width: '400px',
    height: 'auto',
    gap: '12px',
    alignItems: 'center',
})
export const Name_PatientInfo = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    height: '42px',
    width: 'auto',
    gap: '4px'
})
export const PatientInfoPopUp = styled(Box)({
    display: 'flex',
    gap: '4px',
    height: '18px',
    cursor: 'pointer'
})

export const InfoName = styled(Typography)({
    ...mobileTypography.h6,
    color: palette.primary.main

})


export const AllDetails = styled(Box)({
    display: 'flex',
    gap: '20px',
    // width: '643px',
    height: '24px',
    alignItems: 'center'
})

export const Name = styled(Typography)({
    ...typography.h1,
    // width: '164px',
    height: 'auto',
    textWrap: 'nowrap',
    [theme.breakpoints.down('md')]: {
        ...mobileTypography.h3
    },
})



export const TagsContainer = styled(Box)({
    display: 'flex',
    gap: '8px'
})

export const Tags = styled(Chip)({
    width: 'auto',
    height: '33px',
    borderRadius: '100px',
    padding: '4px 12px',
    backgroundColor: palette.primary.light3,
    ...typography.body1
})

export const Icon_Text = styled(Box)({
    // width: '67px',
    height: '24px',
    display: 'flex',
    gap: '8px',
    alignItems: 'center'
})

export const Texts = styled(Typography)({
    color: `${alpha(palette.gery.black, 0.7)}`,
    ...typography.body1,
    textWrap: 'nowrap'
})

export const EditIcon = styled(Avatar)({
    width: '40px',
    height: '40px',
    borderRadius: '50%',
    // padding: '8px 24px',
    backgroundColor: palette.primary.light4,
    cursor: 'pointer'
})

export const TabsContainer = styled(Box)({
    // backgroundColor: 'red',
    height: '68px',
    padding: '0px 32px 0 32px',
    borderBottom: `1px solid ${alpha(palette.gery.black, 0.1)}`,
    boxShadow: shadows[3],
    backgroundColor: palette.gery.white,
    display: 'flex',
    alignItems: 'flex-end',
    [theme.breakpoints.down('md')]: {
        height: '46px !important',
        width: '100%',
        padding: '0px 20px'
    },
})

export const TabsData = styled(Box)({
    backgroundColor: palette.gery.extraLightGray,
    padding: '32px',
    marginTop: '180px',
    [theme.breakpoints.down('md')]: {
        marginTop: '100px',
        padding: '32px 20px',
    },
})
export const ViewBox = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    flexDirection: 'column',
    // justifyContent: 'center',
    // alignItems: 'center',

    height: '780px',
    width: '595px',
    margin: 'auto',
    // marginTop: '10px',
    backgroundColor: palette.gery.white,
    boxShadow: shadows[4]
})
export const ViewBox_1 = styled(Box)({
    width: '595px',
    height: '142px',
    borderBottom: `2.5px solid ${palette.primary.main}`,
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '20px',

})
export const ViewInner = styled(Box)({
    width: '595px',
    display: 'flex',
    justifyContent: 'space-between',
    // backgroundColor: 'red'
})
export const ViewInner_Box1 = styled(Box)({
    display: 'flex',
    flexDirection: 'column',

})
export const ViewInner_Box2 = styled(Box)({
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'flex-end !important',
    alignItems: 'flex-end'
})
export const DoctorName = styled(Typography)({

    color: palette.primary.main,
    // lineHeight: '23px !important',
    fontSize: '18px',
    fontWeight: '500',
    lineHeight: '25px !important'
})
export const DoctDetail = styled(Typography)({
    fontSize: '12px',
    fontWeight: '400',
    color: palette.gery.black,
    lineHeight: '22px',
    letterSpacing: '0%'
})
export const ViewBox_3 = styled(Box)({
    width: '595px',
    height: '142px',
    borderTop: `2.5px solid ${palette.primary.main}`,
    display: 'flex',
    alignItems: 'center',
    padding: '20px',
})
export const ViewBox_2 = styled(Box)({
    width: '595px',
    height: '500px',
    display: 'flex',
    alignItems: 'flex-start',
    padding: '20px',
})
export const HeaderPart = styled(Box)({
    backgroundColor: theme.palette.primary.light3,
    color: theme.palette.gery.black,
    ...theme.typography.h3,
    borderBottom: `1px solid ${theme.palette.primary.light1} !important`,
    padding: '20px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    height: '64px',
    [theme.breakpoints.down('md')]: {
        ...mobileTypography.h4,
    }
})

export const FooterPart = styled(Box)({
    height: "100px",
    padding: '24px 20px',
    display: 'flex',
    justifyContent: 'flex-end',
    alignItems: 'center',
    gap: '16px',
    borderTop: `1px solid ${theme.palette.primary.light1} !important`,
    [theme.breakpoints.down('md')]: {
        gap: '12px',
        padding: '20px 16px',
    },
})

export const StatusHeader = styled(Typography)({

    color: theme.palette.gery.black,
    ...theme.typography.h3,

    [theme.breakpoints.down('md')]: {
        ...mobileTypography.h4,
    }
})

export const PatientNameContainer = styled(Box)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    textAlign: 'center',
    background: palette.primary.light3,
    border: `1px solid ${palette.primary.light2}`,
    padding: '10px 15px',
    borderRadius: '12px',
    marginTop: '8px'

})
export const PatientName = styled(Typography)({

    color: theme.palette.gery.black,
    ...theme.typography.h5,

    [theme.breakpoints.down('md')]: {
        ...mobileTypography.h5,
    }
})

export const TwoBtns = styled(Box)({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'flex-start'
})